.browser {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 18px;
}

.header {
  display: flex;
  gap: 8px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.search {
  flex: 1 1 220px;
  min-width: 0;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border-strong);
  background: var(--color-bg-surface);
  color: var(--color-text, #e4e6eb);
}

.check {
  accent-color: var(--color-accent);
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-sm, 14px);
  color: var(--color-text-subtle);
}

.list {
  background: var(--color-bg-elevated);
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border);
}

.row:last-child {
  border-bottom: none;
}

.info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--fs-sm, 14px);
}

.meta {
  font-size: var(--fs-xs, 12px);
  color: var(--color-text-subtle);
}

.empty {
  color: var(--color-text-subtle);
  font-size: var(--fs-sm, 14px);
}
